export const apiDocs = 'https://developers.berkeleypayment.com';
